import PropTypes from 'prop-types';

import { cn } from '#/lib/utils';
import FmsInfoField from '#/modules/finMgmt/shared/components/FmsInfoField';
import { formatDateOrDash, formatDateTimeOrDash } from '#/utils/date';
import { formatFmsAmount } from '#/modules/finMgmt/shared/helper/fmsAmount';

import { formatVoucherTypeLabel } from '../helper/voucherStatus';
import VoucherStatusBadge from './VoucherStatusBadge';

const TEXT_SPAN = 'sm:col-span-2 md:col-span-2';

function displayOrDash(value) {
  if (value == null || value === '') {
    return '—';
  }
  return value;
}

/** 憑證 detail 上方資訊卡：hero（號碼／狀態／類型／操作）＋ 欄位格。 */
const VoucherMainInfoCard = ({ detail, actions = null }) => {
  const typeLabel = formatVoucherTypeLabel(detail?.voucherType);

  return (
    <div className="receipt-card-elevate">
      <div className="receipt-card-surface p-5">
        <div className="flex flex-wrap items-start justify-between gap-3">
          <div className="min-w-0 flex-1">
            <div className="flex flex-wrap items-center gap-2">
              <h1 className="text-2xl font-bold text-gray-900">
                {detail?.voucherNo || '—'}
              </h1>
              {detail?.status ? <VoucherStatusBadge status={detail.status} /> : null}
            </div>
            <p className="mt-1 text-sm text-gray-600">
              {`${typeLabel}號碼`}
            </p>
          </div>
          {actions ? (
            <div className="flex shrink-0 flex-wrap items-center justify-end gap-2">
              {actions}
            </div>
          ) : null}
        </div>

        <div
          className={cn(
            'mt-4 grid grid-cols-1 gap-x-4 gap-y-3 border-t border-slate-200 pt-4',
            'sm:grid-cols-2 md:grid-cols-4',
          )}
        >
          <FmsInfoField label="類型" value={typeLabel} />
          <FmsInfoField label="憑證日期" value={formatDateOrDash(detail?.voucherDate)} />
          <FmsInfoField label="憑證總額" value={formatFmsAmount(detail?.totalAmount)} />
          <FmsInfoField label="修改" value={formatDateTimeOrDash(detail?.record?.updatedAt)} />

          <FmsInfoField label="建立" value={formatDateTimeOrDash(detail?.record?.createdAt)} />
          <FmsInfoField label="備註" value={displayOrDash(detail?.remark)} className={TEXT_SPAN} />

          {detail?.status === 'CANCELLED' ? (
            <>
              <FmsInfoField label="作廢時間" value={formatDateTimeOrDash(detail?.cancelledAt)} />
              <FmsInfoField
                label="作廢原因"
                value={displayOrDash(detail?.cancelReason)}
                className={TEXT_SPAN}
              />
            </>
          ) : null}
        </div>
      </div>
    </div>
  );
};

VoucherMainInfoCard.propTypes = {
  detail: PropTypes.object.isRequired,
  actions: PropTypes.node,
};

export default VoucherMainInfoCard;
